import { ChangeEvent, useState } from "react";
import SupplierService from "../../services/SupplierService";
import ISupplierSettings from "../../models/ISupplierSettings";
import IQuoteViewOptions from "../../models/IQuoteViewOptions";

/**
 * Custom hook to manage quote view options
 * @param {Object} supplierSettings - Supplier settings object
 * @returns {Array} - [viewOptions, handleViewOptionChange, setViewOptions]
 */
export const useQuoteViewOptions = (
    supplierSettings: ISupplierSettings
): [IQuoteViewOptions, (e: React.ChangeEvent<HTMLInputElement>) => void, React.Dispatch<React.SetStateAction<IQuoteViewOptions>>] => {
    // Initialize view options state
    const [viewOptions, setViewOptions] = useState<IQuoteViewOptions>({
        showPhone: SupplierService.getSupplierSetting(supplierSettings, "show_phone", false, "quote"),
        showEmail: SupplierService.getSupplierSetting(supplierSettings, "show_email", true, "quote"),
        showOrderQty: SupplierService.getSupplierSetting(supplierSettings, "show_order_qty", true, "quote"),
        showOrderDescription: SupplierService.getSupplierSetting(supplierSettings, "show_order_desc", false, "quote"),
        showItemPhoto: SupplierService.getSupplierSetting(supplierSettings, "show_item_photo", false, "quote"),
        showSku: SupplierService.getSupplierSetting(supplierSettings, "show_sku", false, "quote"),
        showUpc: SupplierService.getSupplierSetting(supplierSettings, "show_upc", false, "quote"),
        hideSkuCol: SupplierService.getSupplierSetting(supplierSettings, "hide_sku_col", false, "quote"),
        showBillTo: SupplierService.getSupplierSetting(supplierSettings, "show_bill_to", false, "quote"),
        showBillToPhone: SupplierService.getSupplierSetting(supplierSettings, "show_bill_to_phone", false, "quote"),
        showShipToPhone: SupplierService.getSupplierSetting(supplierSettings, "show_ship_to_phone", false, "quote"),
        showOrderUser: SupplierService.getSupplierSetting(supplierSettings, "show_order_user", false, "quote"),
        showItemLocation: SupplierService.getSupplierSetting(supplierSettings, "show_item_location", false, "quote"),
        showUom: SupplierService.getSupplierSetting(supplierSettings, "show_uom", false, "quote"),
        hideBusinessName: SupplierService.getSupplierSetting(supplierSettings, "hide_business_name", false, "quote"),
        inlineLogoName: SupplierService.getSupplierSetting(supplierSettings, "inline_logo_name", false, "quote"),
        showDimensions: SupplierService.getSupplierSetting(supplierSettings, "show_dimensions", false, "quote"),
    });

    // Handle option changes
    const handleViewOptionChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        setViewOptions((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Return both the state and the handler
    return [viewOptions, handleViewOptionChange, setViewOptions];
};
